import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import styles from './index.css';
import logosheader from '../../assets/logosheader.png';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { wxShareTool } from 'ThreeTerminal_utils';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isShowAppIcon: false,
    };

    androidAppIconHandle = () => {
        const UA = navigator.userAgent.toLocaleLowerCase();

        if (wxShareTool && UA.toLocaleLowerCase().match(/android/) && /micromessenger/i.test(UA)) {
            this.setState({
                isShowAppIcon: false,
            });
        } else {
            this.setState({
                isShowAppIcon: true,
            });
        }

        wxShareTool.on('showAppIcon', () => {
            console.log('showAppIcon激活');
            this.setState({
                isShowAppIcon: true,
            });
        });

        setTimeout(() => {
            if (!this.state.isShowAppIcon) {
                console.log('showAppIcon超时');
                this.setState({
                    isShowAppIcon: true,
                });
            }
        }, 3000);
    };

    componentDidMount() {
        this.androidAppIconHandle();
    }

    render() {
        const { content } = this.props;
        const { isShowAppIcon } = this.state;
        const callImmersiveVideoConfig = {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${content.base62Id}`,
        };

        const wxLaunchHackData = {
            callAppConfig: {
                docType: 'phvideo',
                pid: content?._id,
                kind: 'inter_fxy12',
                noKindFrom: 1,
                download: content.isVideoShare
                    ? ''
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1523668888019',
                downloadAd: content.isVideoShare
                    ? ''
                    : 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8965',
                ...callImmersiveVideoConfig
            },
            statisticsConfig: {
                behavior: 'action',
                type: 'upopen',
                ref: content?.guid,
                kind: 'phvideo',
            },
        };

        return (
            <div className={styles.banner}>
                <div className={styles.pageBottomBox}>
                    <img className={styles.pageBottomLogo} src={logosheader} alt="凤凰新闻" />
                    {isShowAppIcon && <span className={styles.pageBottomButton}>立即打开</span>}
                </div>

                <WxLaunchHack content={wxLaunchHackData} />
            </div>
        );
    }
}

export default errorBoundary(Header);
